
const RoyaleSpacesSchema = {
    "@context": "https://schema.org",
    "@graph": [
        {
            "@type": "WebSite",
            "@id": "https://royalespaces.in/#website",
            "url": "https://royalespaces.in/",
            "name": "Royale Spaces | Open Plots in Amaravati",
            "description": "Royale Spaces is a trusted real estate company in Amaravati offering APCRDA-approved open plots, residential and commercial properties with verified titles and transparent pricing.",
            "publisher": {
                "@id": "https://royalespaces.in/#organization"
            },
            "potentialAction": {
                "@type": "SearchAction",
                "target": {
                    "@type": "EntryPoint",
                    "urlTemplate": "https://royalespaces.in/?s={search_term_string}"
                },
                "query-input": "required name=search_term_string"
            }
        },
        {
            "@type": "Organization",
            "@id": "https://royalespaces.in/#organization",
            "name": "Royale Spaces",
            "legalName": "Royale Spaces",
            "url": "https://royalespaces.in/",
            "logo": {
                "@type": "ImageObject",
                "@id": "https://royalespaces.in/#logo",
                "url": "https://royalespaces.in/wp-content/uploads/2025/02/Logo-1.png",
                "width": 300,
                "height": 300
            },
            "sameAs": [
                "https://www.facebook.com/RoyaleSpacesEstateAgents/",
                "https://x.com/RoyaleSpaces",
                "https://www.instagram.com/royalespaces/",
                "https://www.youtube.com/@RoyaleSpaces"
            ],
            "contactPoint": {
                "@type": "ContactPoint",
                "contactType": "customer support",
                "telephone": "+91-78930-92211",
                "email": "info@royalespaces.com",
                "areaServed": "IN",
                "availableLanguage": ["English", "Telugu"]
            }
        },
        {
            "@type": "WebPage",
            "@id": "https://royalespaces.in/#webpage",
            "url": "https://royalespaces.in/",
            "name": "Royale Spaces | Trusted Real Estate Company in Amaravati",
            "description": "Find verified APCRDA-approved open plots in Amaravati with Royale Spaces. Invest safely with transparent documentation and expert guidance.",
            "isPartOf": {
                "@id": "https://royalespaces.in/#website"
            },
            "about": {
                "@id": "https://royalespaces.in/#organization"
            },
            "primaryImageOfPage": {
                "@id": "https://royalespaces.in/#primaryimage"
            },
            "breadcrumb": {
                "@id": "https://royalespaces.in/#breadcrumb"
            }
        },
        {
            "@type": "ImageObject",
            "@id": "https://royalespaces.in/#primaryimage",
            "url": "https://royalespaces.in/og-image.jpg",
            "width": 1200,
            "height": 630
        },
        {
            "@type": "BreadcrumbList",
            "@id": "https://royalespaces.in/#breadcrumb",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://royalespaces.in/"
                }
            ]
        }
    ]
};

export default RoyaleSpacesSchema;
